import React, { useEffect, useState } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from 'recharts';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';
import { lightPalette } from '../../../theme';
import { getUserStatistics } from '../../../services/adminDashboard';

const UsersPieChart = () => {
  const OUTER_CHART = 'outerChart';
  const [userChartData, setUserChartData] = useState([
    { name: 'Total User', value: 0 },
    { name: 'Active User', value: 0 },
    { name: 'Inactive User', value: 0 },
    { name: 'Invited User', value: 0 },
  ]);

  const [loading, setLoading] = useState(true);

  const COLORS = [
    'rgba(237, 227, 255, 1)',
    'rgba(210, 187, 254, 1)',
    'rgba(185, 150, 252, 1)',
    'rgba(159, 119, 235, 1)',
  ];

  const getUsersCountData = async () => {
    const response = await getUserStatistics();
    if (response && Object.keys(response?.data?.stages)?.length > 0) {
      const finalData = response.data.stages;
      setUserChartData([
        { name: 'Total User', value: finalData?.total_users },
        { name: 'Active User', value: finalData?.active_users },
        { name: 'Inactive User', value: finalData?.inactive_users },
        { name: 'Invited User', value: finalData?.invited_users },
      ]);
      setLoading(false);
    } else {
      setUserChartData([]);
      setLoading(true);
    }
  };

  useEffect(() => {
    getUsersCountData();
  }, []);

  const tooltipFormatter = (value, name) => [value, name];

  const renderLegend = (props) => {
    const { payload } = props;

    return (
      <Box
        sx={{
          display: 'flex',
          width: '100%',
        }}
      >
        <Box
          sx={{
            maxWidth: '120px',
            width: '100%',
            margin: 'auto',
          }}
        >
          {payload
            ?.filter((item) => item?.payload?.name !== OUTER_CHART)
            .map((entry, index) => (
              <Box
                key={`${index + 1}`}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  key={`${index + 1}`}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      marginRight: '8px',
                      backgroundColor: entry?.color || 'black',
                    }}
                  />
                  <Box
                    sx={{
                      color: lightPalette.deepAmethyst.semiDark,
                    }}
                  >
                    {entry.value}
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    marginLeft: '20px',
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: 'Heebo',
                      fontWeight: '500',
                      color: lightPalette.deepAmethyst.main,
                    }}
                  >
                    {entry?.payload?.value}
                  </Typography>
                </Box>
              </Box>
            ))}
        </Box>
      </Box>
    );
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Box
      sx={{
        height: '100%',
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={400} height={200}>
          <Pie
            data={[{ name: OUTER_CHART, value: 100 }]}
            cx="50%"
            cy="50%"
            innerRadius={90}
            outerRadius={92}
            fill="rgba(237, 227, 255, 1)"
          />
          <Pie
            data={userChartData}
            innerRadius={65}
            outerRadius={85}
            dataKey="value"
          >
            {userChartData?.map((entry, index) => (
              <Cell
                key={`cell-${index + 1}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={tooltipFormatter}
            contentStyle={{
              backgroundColor: 'rgba(255, 255, 255, 1)',
              color: 'rgba(0, 0, 0, 0.6)',
              boxShadow: '0px 0px 11px 4px rgba(0, 0, 0, 0.08)',
              borderRadius: '5px',
              padding: '10px',
            }}
            labelStyle={{ display: 'none' }}
            itemStyle={{ color: 'rgba(0, 0, 0, 0.6)' }}
          />
          <Legend
            align="right"
            verticalAlign="middle"
            width="27.5%"
            content={renderLegend}
          />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

UsersPieChart.defaultProps = {
  payload: [],
};

UsersPieChart.propTypes = {
  payload: PropTypes.arrayOf(),
};

export default UsersPieChart;
